import React, { FC, useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import Select from 'react-select'
import { fetchData, getEncryptedRoute, toasterrormsg, toastsuccessmsg, useMenuIdPermissions } from '../../../reusable'
import { ToastContainer } from 'react-toastify'
import { AddCarRentalHeader } from './AddCarRentalHeader'
import PriceInput from '../components/PriceInput'
import { Tr } from '../../../_metronic/i18n/Tr'

const AddCarRentalInsurance: FC = () => {
  let t = Tr()
  const { menuId } = useMenuIdPermissions()

  const location = useLocation()
  const editCarrentalId = (location.state as any)?.carrentalId || ''
  const [carRentalDetails, setCarRentalDetails] = useState([])
  var vendorId = ''
  const vendorData = sessionStorage.getItem('vendor')
  if (vendorData) {
    var vendor = JSON.parse(vendorData)
    vendorId = vendor.vendorId
  } else {
  }
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const [insuranceBasicNameEN, setInsuranceBasicNameEN] = useState('')
  const [insuranceBasicNameRU, setInsuranceBasicNameRU] = useState('')
  const [insuranceBasicNameUZ, setInsuranceBasicNameUZ] = useState('')
  const [insuranceBasicPrice, setInsuranceBasicPrice] = useState('')
  const [insurancePremiumNameEN, setInsurancePremiumNameEN] = useState('')
  const [insurancePremiumNameRU, setInsurancePremiumNameRU] = useState('')
  const [insurancePremiumNameUZ, setInsurancePremiumNameUZ] = useState('')
  const [insurancePremiumPrice, setInsurancePremiumPrice] = useState('')
  const [insurancePremiumCoverageLimit, setInsurancePremiumCoverageLimit] = useState("");
  const primaryLanguage = sessionStorage.getItem('primaryLanguage')

  const [basicWhatsIncludedFields, setBasicWhatsIncludedFields] = useState([
    { en_title: '', ru_title: '', uz_title: '', status: null },
  ])


  const [basicErrors, serBasicErrors] = useState([
    { en_title: '', ru_title: '', uz_title: '', status: '' },
  ])

  const [isBasicIncludedStatus] = useState([
    { label: 'Included', value: true },
    { label: 'Not Included', value: false },
  ])

  const handleAddBasicField = () => {
    setBasicWhatsIncludedFields([
      ...basicWhatsIncludedFields,
      { en_title: '', ru_title: '', uz_title: '', status: null },
    ])
    serBasicErrors([...basicErrors, { en_title: '', ru_title: '', uz_title: '', status: '' }])
  }

  const handleRemoveBasicField = (index: any) => {
    if (index === 0) return // Prevent removal of the first field
    const newFields = basicWhatsIncludedFields.filter((_, i) => i !== index)
    const newErrors = basicErrors.filter((_, i) => i !== index)
    setBasicWhatsIncludedFields(newFields)
    serBasicErrors(newErrors)
  }

  const handleBasicChange = (index: any, event: any) => {
    const { name, value } = event.target
    const newFields = basicWhatsIncludedFields.map((field, i) =>
      i === index ? { ...field, [name]: value } : field
    )
    setBasicWhatsIncludedFields(newFields)

    // Clear error for the current field
    removeBasicErrors(index, name)
  }

  const handleBasicStatusChange = (index: any, selectedOption: any) => {
    const newFields = basicWhatsIncludedFields.map((field, i) =>
      i === index ? { ...field, status: selectedOption.value } : field
    )
    setBasicWhatsIncludedFields(newFields)

    // Clear error for the status field
    removeBasicErrors(index, 'status')
  }

  const removeBasicErrors = (index: any, fieldName: any) => {
    let newError = [...basicErrors] as any
    if (!newError[index]) {
      newError[index] = {}
    }
    newError[index][fieldName] = '' // Clear error
    serBasicErrors(newError)
  }

  const [showPremium, setShowPremium] = useState(false)
  const [premiumWhatsIncludedFields, setPremiumWhatsIncludedFields] = useState([
    { en_title: '', ru_title: '', uz_title: '', status: null },
  ])


  const [premiumErrors, setPremiumErrors] = useState([
    { en_title: '', ru_title: '', uz_title: '', status: '' },
  ])

  const [isPremiumIncludedStatus] = useState([
    { label: 'Included', value: true },
    { label: 'Not Included', value: false },
  ])

  const handleAddPremiumField = () => {
    setPremiumWhatsIncludedFields([
      ...premiumWhatsIncludedFields,
      { en_title: '', ru_title: '', uz_title: '', status: null },
    ])
    setPremiumErrors([...premiumErrors, { en_title: '', ru_title: '', uz_title: '', status: '' }])
  }

  const handleRemovePremiumField = (index: any) => {
    if (index === 0) return // Prevent removal of the first field
    const newFields = premiumWhatsIncludedFields.filter((_, i) => i !== index)
    const newErrors = premiumErrors.filter((_, i) => i !== index)
    setPremiumWhatsIncludedFields(newFields)
    setPremiumErrors(newErrors)
  }

  const handlePremiumChange = (index: any, event: any) => {
    const { name, value } = event.target
    const newFields = premiumWhatsIncludedFields.map((field, i) =>
      i === index ? { ...field, [name]: value } : field
    )
    setPremiumWhatsIncludedFields(newFields)

    // Clear error for the current field
    removePremiumErrors(index, name)
  }

  const handlePremiumStatusChange = (index: any, selectedOption: any) => {
    const newFields = premiumWhatsIncludedFields.map((field, i) =>
      i === index ? { ...field, status: selectedOption.value } : field
    )
    setPremiumWhatsIncludedFields(newFields)

    // Clear error for the status field
    removePremiumErrors(index, 'status')
  }

  const removePremiumErrors = (index: any, fieldName: any) => {
    let newError = [...premiumErrors] as any
    if (!newError[index]) {
      newError[index] = {}
    }
    newError[index][fieldName] = '' // Clear error
    setPremiumErrors(newError)
  }
  // set error state
  const [error, setError] = useState([
    {
      insuranceBasicNameEN: '',
      insuranceBasicNameRU: '',
      insuranceBasicNameUZ: '',
      insuranceBasicPrice: '',
      insurancePremiumNameEN: '',
      insurancePremiumNameRU: '',
      insurancePremiumNameUZ: '',
      insurancePremiumPrice: '',
      insurancePremiumCoverageLimit: '',

    },
  ])

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }

  // validation function
  const validate = () => {
    var isValid = true
    var errorTmp = [...error]

    if (
      insuranceBasicPrice == '' ||
      insuranceBasicPrice == null ||
      insuranceBasicPrice == undefined
    ) {
      errorTmp[0].insuranceBasicPrice = t('Price Is Required')
      isValid = false
    }
    if (primaryLanguage == 'English') {
      if (
        insuranceBasicNameEN.trim() == '' ||
        insuranceBasicNameEN.trim() == null ||
        insuranceBasicNameEN.trim() == undefined
      ) {
        errorTmp[0].insuranceBasicNameEN = t('Insurance Name Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Russian') {
      if (
        insuranceBasicNameRU.trim() == '' ||
        insuranceBasicNameRU.trim() == null ||
        insuranceBasicNameRU.trim() == undefined
      ) {
        errorTmp[0].insuranceBasicNameRU = t('Insurance Name Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Uzbek') {
      if (
        insuranceBasicNameUZ.trim() == '' ||
        insuranceBasicNameUZ.trim() == null ||
        insuranceBasicNameUZ.trim() == undefined
      ) {
        errorTmp[0].insuranceBasicNameUZ = t('Insurance Name Is Required')
        isValid = false
      }
    }
    var basicErrorTmps = [...basicErrors]
    // Validate basicWhatsIncludedFields
    basicWhatsIncludedFields.forEach((field: any, index: any) => {
      if (!basicErrorTmps[index]) {
        basicErrorTmps[index] = {} as any
      }

      if (field.status === null || field.status === undefined) {
        basicErrorTmps[index].status = t('Status Is Required')
        isValid = false
      } else {
        basicErrorTmps[index].status = '' // Clear error if status is selected
      }

      if (primaryLanguage === 'English') {
        if (!field.en_title || !field.en_title.trim()) {
          basicErrorTmps[index].en_title = t('Title Is Required')
          isValid = false
        }
      } else if (primaryLanguage === 'Russian') {
        if (!field.ru_title || !field.ru_title.trim()) {
          basicErrorTmps[index].ru_title = t('Title Is Required')
          isValid = false
        }
      } else if (primaryLanguage === 'Uzbek') {
        if (!field.uz_title || !field.uz_title.trim()) {
          basicErrorTmps[index].uz_title = t('Title Is Required')
          isValid = false
        }
      }
    })
    serBasicErrors(basicErrorTmps)

    if (showPremium) {
      if (
        insurancePremiumPrice == '' ||
        insurancePremiumPrice == null ||
        insurancePremiumPrice == undefined
      ) {
        errorTmp[0].insurancePremiumPrice = t('Price Is Required')
        isValid = false
      }

      if (insurancePremiumCoverageLimit == "" || insurancePremiumCoverageLimit == null || insurancePremiumCoverageLimit == undefined) {
        errorTmp[0].insurancePremiumCoverageLimit = t('Coverage Limit Is Required');
        isValid = false;
      } else if (parseFloat(insurancePremiumCoverageLimit) > parseFloat(insurancePremiumPrice)) {
        errorTmp[0].insurancePremiumCoverageLimit = t('Coverage Limit Must Be Less Than Or Equal To Price');
        isValid = false;
      }


      if (primaryLanguage == 'English') {
        if (
          insurancePremiumNameEN.trim() == '' ||
          insurancePremiumNameEN.trim() == null ||
          insurancePremiumNameEN.trim() == undefined
        ) {
          errorTmp[0].insurancePremiumNameEN = t('Insurance Name Is Required')
          isValid = false
        }
      } else if (primaryLanguage == 'Russian') {
        if (
          insurancePremiumNameRU.trim() == '' ||
          insurancePremiumNameRU.trim() == null ||
          insurancePremiumNameRU.trim() == undefined
        ) {
          errorTmp[0].insurancePremiumNameRU = t('Insurance Name Is Required')
          isValid = false
        }
      } else if (primaryLanguage == 'Uzbek') {
        if (
          insurancePremiumNameUZ.trim() == '' ||
          insurancePremiumNameUZ.trim() == null ||
          insurancePremiumNameUZ.trim() == undefined
        ) {
          errorTmp[0].insurancePremiumNameUZ = t('Insurance Name Is Required')
          isValid = false
        }
      }
      var premiumErrorTmps = [...premiumErrors]

      // Validate premiumWhatsIncludedFields
      premiumWhatsIncludedFields.forEach((field: any, index: any) => {
        if (!premiumErrorTmps[index]) {
          premiumErrorTmps[index] = {} as any
        }

        if (field.status === null || field.status === undefined) {
          premiumErrorTmps[index].status = t('Status Is Required')
          isValid = false
        } else {
          premiumErrorTmps[index].status = '' // Clear error if status is selected
        }

        if (primaryLanguage === 'English') {
          if (!field.en_title || !field.en_title.trim()) {
            premiumErrorTmps[index].en_title = t('Title Is Required')
            isValid = false
          }
        } else if (primaryLanguage === 'Russian') {
          if (!field.ru_title || !field.ru_title.trim()) {
            premiumErrorTmps[index].ru_title = t('Title Is Required')
            isValid = false
          }
        } else if (primaryLanguage === 'Uzbek') {
          if (!field.uz_title || !field.uz_title.trim()) {
            premiumErrorTmps[index].uz_title = t('Title Is Required')
            isValid = false
          }
        }
      })

      setPremiumErrors(premiumErrorTmps)
    }

    setError(errorTmp)
    return isValid
  }
  // add Car rental location api call
  const addCarRentalInsuranceApi = async () => {
    if (validate()) {
      setDisable(true)
      setLoading(true)
      var param: any = {
        carrentalId: String(editCarrentalId),
        en_basicName: insuranceBasicNameEN,
        ru_basicName: insuranceBasicNameRU,
        uz_basicName: insuranceBasicNameUZ,
        basicPrice: insuranceBasicPrice,
        basicIncluded: basicWhatsIncludedFields,
      }
      if (showPremium) {
        param['en_premiumName'] = insurancePremiumNameEN
        param['ru_premiumName'] = insurancePremiumNameRU
        param['uz_premiumName'] = insurancePremiumNameUZ
        param['premiumPrice'] = insurancePremiumPrice
        param['premiumIncluded'] = premiumWhatsIncludedFields
        param['premiumCoverageLimit'] = insurancePremiumCoverageLimit

      }
      var response: any = await fetchData('vendor/public/addinsurance', param)
      if (response.status == '200') {
        toastsuccessmsg('Insurance Saved Successfully!')
        const state = {
          carrentalId: editCarrentalId,
        }
        setTimeout(() => {
          navigate(getEncryptedRoute('../addcarrentaldocuments/', { menuId: menuId }), { state })

          setDisable(false)
          setLoading(false)
        }, 1500)
      } else {
        toasterrormsg(response.message)
        setDisable(false)
        setLoading(false)
      }
    }
  }

  // Car rental Details api call
  const carrentalDetailsApiCall = async () => {
    var param: any = {
      carrentalId: String(editCarrentalId),
    }
    var response: any = await fetchData('vendor/public/carrentalDetail', param)

    if (response.status == '200') {
      var data = response.data[0]

      setCarRentalDetails(response.data)
      setInsuranceBasicNameEN(data.en_basicName)
      setInsuranceBasicNameRU(data.ru_basicName)
      setInsuranceBasicNameUZ(data.uz_basicName)
      setInsuranceBasicPrice(data.basicPrice + '')
      if (data.basicIncluded.length != 0) {
        setBasicWhatsIncludedFields(data.basicIncluded)
      }
      if (data.premiumIncluded.length != 0) {
        setShowPremium(true)
        setInsurancePremiumNameEN(data.en_premiumName)
        setInsurancePremiumNameRU(data.ru_premiumName)
        setInsurancePremiumNameUZ(data.uz_premiumName)
        setInsurancePremiumPrice(data.premiumPrice + '')
        setPremiumWhatsIncludedFields(data.premiumIncluded)
        setInsurancePremiumCoverageLimit(data.premiumCoverageLimit + '')

      }
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    if (editCarrentalId != '') {
      carrentalDetailsApiCall()
    }
  }, [])

  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>
        {editCarrentalId != '' ? t('Edit Insurance') : t('Add Insurance')}
      </PageTitle>
      <AddCarRentalHeader carrentalId={editCarrentalId} />
      <div className='d-flex flex-column flex-column-fluid'>
        {/* <!--begin::Content--> */}
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          {/* <!--begin::Form--> */}
          <div className='form d-flex flex-column flex-lg-row'>
            {/* <!--begin::Main column--> */}
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              {/* <!--begin::Tab content--> */}
              <div className='tab-content'>
                {/* <!--begin::Tab pane--> */}
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    {/* <!--begin::General options--> */}
                    <div className='card card-flush py-4'>
                      {/* <!--begin::Card header--> */}
                      <div className='card-header d-flex'>
                        {/* <!--begin::Card title--> */}
                        <div className='card-title'>
                          <h2>{t('Car Rental Insurance')}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                        <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                          {carRentalDetails.length != 0 ? (
                            <>
                              {carRentalDetails.map((completedSteps: any, index: any) => {
                                var percentage = 0
                                if (completedSteps['completedSteps']['basicInfo']) {
                                  percentage = 10
                                }
                                if (completedSteps['completedSteps']['location']) {
                                  percentage = 20
                                }
                                if (completedSteps['completedSteps']['carRentalInfo']) {
                                  percentage = 40
                                }
                                if (completedSteps['completedSteps']['photos']) {
                                  percentage = 50
                                }
                                if (completedSteps['completedSteps']['insurance']) {
                                  percentage = 60
                                }
                                if (completedSteps['completedSteps']['documentsRequired']) {
                                  percentage = 70
                                }
                                if (completedSteps['completedSteps']['availability']) {
                                  percentage = 70
                                }
                                if (completedSteps['completedSteps']['pickupDropoffInfo']) {
                                  percentage = 80
                                }
                                if (completedSteps['completedSteps']['policies']) {
                                  percentage = 90
                                }
                                if (completedSteps['completedSteps']['financeAndLegal']) {
                                  percentage = 100
                                }
                                return (
                                  <>
                                    <div className='d-flex justify-content-between w-100 mt-auto'>
                                      <span className='fw-bold fs-6'>{t('Completion')}</span>
                                      <span className='fw-bolder fs-6'>{percentage}%</span>
                                    </div>
                                    <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                      <div
                                        className='bg-success rounded h-5px'
                                        role='progressbar'
                                        style={{ width: `${percentage}%` }}
                                      ></div>
                                    </div>
                                  </>
                                )
                              })}
                            </>
                          ) : (
                            <>
                              <div className='d-flex justify-content-between w-100 mt-auto'>
                                <span className='fw-bold fs-6'>{t('Completion')}</span>
                                <span className='fw-bolder fs-6'>0%</span>
                              </div>
                              <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                <div
                                  className='bg-success rounded h-5px'
                                  role='progressbar'
                                  style={{ width: '0%' }}
                                ></div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {/* <!--end::Card header--> */}
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-10'>
                        <div className='col-lg-12'>
                          <label className='fs-2 form-label fw-bold'>{t('Basic:')}</label>
                        </div>
                        {/* <!--begin::Input group--> */}
                        <div className='row'>
                          {primaryLanguage == 'English' && (
                            <>
                              <div className='col-lg-3 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Name (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='insuranceBasicNameEN'
                                  className='form-control mb-2'
                                  placeholder='Name'
                                  value={insuranceBasicNameEN}
                                  onChange={(e) => {
                                    setInsuranceBasicNameEN(e.target.value)
                                    removeError('insuranceBasicNameEN')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].insuranceBasicNameEN}
                                </div>
                              </div>
                              <div className='col-lg-3 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>{t('Name (Russian)')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='insuranceBasicNameRU'
                                  className='form-control mb-2'
                                  placeholder='Name'
                                  value={insuranceBasicNameRU}
                                  onChange={(e) => {
                                    setInsuranceBasicNameRU(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-3 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>{t('Name (Uzbek)')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='insuranceBasicNameUZ'
                                  className='form-control mb-2'
                                  placeholder='Name'
                                  value={insuranceBasicNameUZ}
                                  onChange={(e) => {
                                    setInsuranceBasicNameUZ(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </>
                          )}
                          {primaryLanguage == 'Russian' && (
                            <>
                              <div className='col-lg-3 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>{t('Name (Russian)')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='insuranceBasicNameRU'
                                  className='form-control mb-2'
                                  placeholder='Name'
                                  value={insuranceBasicNameRU}
                                  onChange={(e) => {
                                    setInsuranceBasicNameRU(e.target.value)
                                    removeError('insuranceBasicNameRU')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].insuranceBasicNameRU}
                                </div>
                              </div>
                              <div className='col-lg-3 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Name (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='insuranceBasicNameEN'
                                  className='form-control mb-2'
                                  placeholder='Name'
                                  value={insuranceBasicNameEN}
                                  onChange={(e) => {
                                    setInsuranceBasicNameEN(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-3 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>{t('Name (Uzbek)')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='insuranceBasicNameUZ'
                                  className='form-control mb-2'
                                  placeholder='Name'
                                  value={insuranceBasicNameUZ}
                                  onChange={(e) => {
                                    setInsuranceBasicNameUZ(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </>
                          )}
                          {primaryLanguage == 'Uzbek' && (
                            <>
                              <div className='col-lg-3 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>{t('Name (Uzbek)')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='insuranceBasicNameUZ'
                                  className='form-control mb-2'
                                  placeholder='Name'
                                  value={insuranceBasicNameUZ}
                                  onChange={(e) => {
                                    setInsuranceBasicNameUZ(e.target.value)
                                    removeError('insuranceBasicNameUZ')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>
                                  {error[0].insuranceBasicNameUZ}
                                </div>
                              </div>
                              <div className='col-lg-3 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>{t('Name (Russian)')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='insuranceBasicNameRU'
                                  className='form-control mb-2'
                                  placeholder='Name'
                                  value={insuranceBasicNameRU}
                                  onChange={(e) => {
                                    setInsuranceBasicNameRU(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-3 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Name (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='insuranceBasicNameEN'
                                  className='form-control mb-2'
                                  placeholder='Name'
                                  value={insuranceBasicNameEN}
                                  onChange={(e) => {
                                    setInsuranceBasicNameEN(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </>
                          )}
                          <div className='col-lg-3 my-3'>
                            <PriceInput
                              labelClass='required fs-5 form-label'
                              label={t('Price (By Day)')}
                              inputClass='form-control border-right-0'
                              placeholder='Price'
                              value={insuranceBasicPrice}
                              onChange={(e: any) => {
                                setInsuranceBasicPrice(e)
                                removeError('insuranceBasicPrice')
                              }}
                            />
                            <div className='text-danger fw-bold'>
                              {error[0].insuranceBasicPrice}
                            </div>
                          </div>
                        </div>
                        {basicWhatsIncludedFields.map((field, index) => (
                          <div key={index}>
                            <div className='row'>
                              <div className='col-lg-3 my-3'>
                                <label className='required fs-4 form-label required'>
                                  {t('Insurance Coverage')}
                                </label>
                                <Select
                                  name='status[]'
                                  id='status'
                                  placeholder={t('Select Status')}
                                  className='mb-1'
                                  isSearchable={true}
                                  options={isBasicIncludedStatus}
                                  value={isBasicIncludedStatus.find(
                                    (option) => option.value === field.status
                                  )}
                                  onChange={(selectedOption) =>
                                    handleBasicStatusChange(index, selectedOption)
                                  }
                                />
                                {basicErrors[index]?.status && (
                                  <div className='text-danger fw-bold'>
                                    {basicErrors[index].status}
                                  </div>
                                )}
                              </div>
                              {primaryLanguage === 'English' && (
                                <>
                                  <div className='col-lg-3 my-3'>
                                    <label className='required fs-5 form-label'>
                                      {t('Title (English)')}
                                    </label>
                                    <input
                                      type='text'
                                      name='en_title'
                                      className='form-control mb-2'
                                      placeholder={t('Title')}
                                      value={field.en_title}
                                      onChange={(event) => handleBasicChange(index, event)}
                                    />
                                    {basicErrors[index]?.en_title && (
                                      <div className='text-danger fw-bold'>
                                        {basicErrors[index].en_title}
                                      </div>
                                    )}
                                  </div>
                                  <div className='col-lg-3 my-3'>
                                    <label className='fs-5 form-label'>
                                      {t('Title (Russian)')}
                                    </label>
                                    <input
                                      type='text'
                                      name='ru_title'
                                      className='form-control mb-2'
                                      placeholder={t('Title')}
                                      value={field.ru_title}
                                      onChange={(event) => handleBasicChange(index, event)}
                                    />
                                  </div>
                                  <div className='col-lg-3 my-3'>
                                    <label className='fs-5 form-label'>{t('Title (Uzbek)')}</label>
                                    <input
                                      type='text'
                                      name='uz_title'
                                      className='form-control mb-2'
                                      placeholder={t('Title')}
                                      value={field.uz_title}
                                      onChange={(event) => handleBasicChange(index, event)}
                                    />
                                  </div>
                                </>
                              )}
                              {primaryLanguage === 'Russian' && (
                                <>
                                  <div className='col-lg-3 my-3'>
                                    <label className='required fs-5 form-label'>
                                      {t('Title (Russian)')}
                                    </label>
                                    <input
                                      type='text'
                                      name='ru_title'
                                      className='form-control mb-2'
                                      placeholder={t('Title')}
                                      value={field.ru_title}
                                      onChange={(event) => handleBasicChange(index, event)}
                                    />
                                    {basicErrors[index]?.ru_title && (
                                      <div className='text-danger fw-bold'>
                                        {basicErrors[index].ru_title}
                                      </div>
                                    )}
                                  </div>
                                  <div className='col-lg-3 my-3'>
                                    <label className='fs-5 form-label'>
                                      {t('Title (English)')}
                                    </label>
                                    <input
                                      type='text'
                                      name='en_title'
                                      className='form-control mb-2'
                                      placeholder={t('Title')}
                                      value={field.en_title}
                                      onChange={(event) => handleBasicChange(index, event)}
                                    />
                                  </div>
                                  <div className='col-lg-3 my-3'>
                                    <label className='fs-5 form-label'>{t('Title (Uzbek)')}</label>
                                    <input
                                      type='text'
                                      name='uz_title'
                                      className='form-control mb-2'
                                      placeholder={t('Title')}
                                      value={field.uz_title}
                                      onChange={(event) => handleBasicChange(index, event)}
                                    />
                                  </div>
                                </>
                              )}
                              {primaryLanguage === 'Uzbek' && (
                                <>
                                  <div className='col-lg-3 my-3'>
                                    <label className='required fs-5 form-label'>
                                      {t('Title (Uzbek)')}
                                    </label>
                                    <input
                                      type='text'
                                      name='uz_title'
                                      className='form-control mb-2'
                                      placeholder={t('Title')}
                                      value={field.uz_title}
                                      onChange={(event) => handleBasicChange(index, event)}
                                    />
                                    {basicErrors[index]?.uz_title && (
                                      <div className='text-danger fw-bold'>
                                        {basicErrors[index].uz_title}
                                      </div>
                                    )}
                                  </div>
                                  <div className='col-lg-3 my-3'>
                                    <label className='fs-5 form-label'>
                                      {t('Title (Russian)')}
                                    </label>
                                    <input
                                      type='text'
                                      name='ru_title'
                                      className='form-control mb-2'
                                      placeholder={t('Title')}
                                      value={field.ru_title}
                                      onChange={(event) => handleBasicChange(index, event)}
                                    />
                                  </div>
                                  <div className='col-lg-3 my-3'>
                                    <label className='fs-5 form-label'>
                                      {t('Title (English)')}
                                    </label>
                                    <input
                                      type='text'
                                      name='en_title'
                                      className='form-control mb-2'
                                      placeholder={t('Title')}
                                      value={field.en_title}
                                      onChange={(event) => handleBasicChange(index, event)}
                                    />
                                  </div>
                                </>
                              )}
                              <div className='col-lg-12 mb-3 d-flex justify-content-end align-items-end'>
                                {index !== 0 && (
                                  <button
                                    className='btn btn-danger mx-1 mb-2'
                                    onClick={() => handleRemoveBasicField(index)}
                                  >
                                    x
                                  </button>
                                )}
                                <button
                                  className='btn btn-success mx-1 mb-2'
                                  onClick={handleAddBasicField}
                                >
                                  +
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                        {/* <!--end::Input group--> */}
                        <div className='col-lg-12 mb-5'>
                          <button
                            className='btn btn-success'
                            onClick={() => setShowPremium(!showPremium)}
                          >
                            {t('Add Premium')}
                          </button>
                        </div>
                        {showPremium && (
                          <>
                            <div className='col-lg-12'>
                              <label className='fs-2 form-label fw-bold'>{t('Premium:')}</label>
                            </div>
                            <div className='row'>
                              {primaryLanguage == 'English' && (
                                <>
                                  <div className='col-lg-3 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-4 form-label'>
                                      {("Name (English)")}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='insurancePremiumNameEN'
                                      className='form-control mb-2'
                                      placeholder={t("Name")}
                                      value={insurancePremiumNameEN}
                                      onChange={(e) => {
                                        setInsurancePremiumNameEN(e.target.value)
                                        removeError('insurancePremiumNameEN')
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                    <div className='text-danger fw-bold'>
                                      {error[0].insurancePremiumNameEN}
                                    </div>
                                  </div>
                                  <div className='col-lg-3 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>{t("Name (Russian)")}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='insurancePremiumNameRU'
                                      className='form-control mb-2'
                                      placeholder={t("Name")}
                                      value={insurancePremiumNameRU}
                                      onChange={(e) => {
                                        setInsurancePremiumNameRU(e.target.value)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-3 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>{t("Name (Uzbek)")}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='insurancePremiumNameUZ'
                                      className='form-control mb-2'
                                      placeholder={t("Name")}
                                      value={insurancePremiumNameUZ}
                                      onChange={(e) => {
                                        setInsurancePremiumNameUZ(e.target.value)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                </>
                              )}
                              {primaryLanguage == 'Russian' && (
                                <>
                                  <div className='col-lg-3 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-4 form-label'>
                                      {t("Name (Russian)")}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='insurancePremiumNameRU'
                                      className='form-control mb-2'
                                      placeholder={t("Name")}
                                      value={insurancePremiumNameRU}
                                      onChange={(e) => {
                                        setInsurancePremiumNameRU(e.target.value)
                                        removeError('insurancePremiumNameRU')
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                    <div className='text-danger fw-bold'>
                                      {error[0].insurancePremiumNameRU}
                                    </div>
                                  </div>
                                  <div className='col-lg-3 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>{t("Name (English)")}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='insurancePremiumNameEN'
                                      className='form-control mb-2'
                                      placeholder={t("Name")}
                                      value={insurancePremiumNameEN}
                                      onChange={(e) => {
                                        setInsurancePremiumNameEN(e.target.value)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-3 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className=' fs-4 form-label'>{t("Name (Uzbek)")}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='insurancePremiumNameUZ'
                                      className='form-control mb-2'
                                      placeholder={t("Name")}
                                      value={insurancePremiumNameUZ}
                                      onChange={(e) => {
                                        setInsurancePremiumNameUZ(e.target.value)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                </>
                              )}
                              {primaryLanguage == 'Uzbek' && (
                                <>
                                  <div className='col-lg-3 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-4 form-label'>{t("Name (Uzbek)")}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='insurancePremiumNameUZ'
                                      className='form-control mb-2'
                                      placeholder={t("Name")}
                                      value={insurancePremiumNameUZ}
                                      onChange={(e) => {
                                        setInsurancePremiumNameUZ(e.target.value)
                                        removeError('insurancePremiumNameUZ')
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                    <div className='text-danger fw-bold'>
                                      {error[0].insurancePremiumNameUZ}
                                    </div>
                                  </div>
                                  <div className='col-lg-3 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className=' fs-4 form-label'>{t("Name (Russian)")}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='insurancePremiumNameRU'
                                      className='form-control mb-2'
                                      placeholder={t("Name")}
                                      value={insurancePremiumNameRU}
                                      onChange={(e) => {
                                        setInsurancePremiumNameRU(e.target.value)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-3 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className=' fs-4 form-label'>{t("Name (English)")}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='insurancePremiumNameEN'
                                      className='form-control mb-2'
                                      placeholder={t("Name")}
                                      value={insurancePremiumNameEN}
                                      onChange={(e) => {
                                        setInsurancePremiumNameEN(e.target.value)
                                      }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                </>
                              )}
                              <div className='col-lg-3 my-3'>
                                <PriceInput
                                  labelClass='required fs-5 form-label'
                                  label={t('Price (By Day)')}
                                  inputClass='form-control border-right-0'
                                  placeholder='Price'
                                  value={insurancePremiumPrice}
                                  onChange={(e: any) => {
                                    setInsurancePremiumPrice(e)
                                    removeError('insurancePremiumPrice')
                                  }}
                                />
                                <div className='text-danger fw-bold'>
                                  {error[0].insurancePremiumPrice}
                                </div>
                              </div>

                              <div className="col-lg-3 my-3">
                                <PriceInput
                                  labelClass="required fs-5 form-label"
                                  label={t("Coverage Limit")}
                                  inputClass="form-control border-right-0"
                                  placeholder={t("Coverage Limit")}
                                  value={insurancePremiumCoverageLimit}
                                  onChange={(e: any) => { setInsurancePremiumCoverageLimit(e); removeError("insurancePremiumCoverageLimit"); }}
                                />
                                <div className='text-danger fw-bold'>{error[0].insurancePremiumCoverageLimit}</div>
                              </div>
                            </div>
                            {premiumWhatsIncludedFields.map((field, index) => (
                              <div key={index}>
                                <div className='row'>
                                  <div className='col-lg-3 my-3'>
                                    <label className='required fs-4 form-label required'>
                                      {t("Insurance Coverage")}
                                    </label>
                                    <Select
                                      name='status[]'
                                      id='status'
                                      placeholder={t('Select Status')}
                                      className='mb-1'
                                      isSearchable={true}
                                      options={isPremiumIncludedStatus}
                                      value={isPremiumIncludedStatus.find(
                                        (option) => option.value === field.status
                                      )}
                                      onChange={(selectedOption) =>
                                        handlePremiumStatusChange(index, selectedOption)
                                      }
                                    />
                                    {premiumErrors[index]?.status && (
                                      <div className='text-danger fw-bold'>
                                        {premiumErrors[index].status}
                                      </div>
                                    )}
                                  </div>
                                  {primaryLanguage === 'English' && (
                                    <>
                                      <div className='col-lg-3 my-3'>
                                        <label className='required fs-5 form-label'>
                                          {t("Title (English)")}
                                        </label>
                                        <input
                                          type='text'
                                          name='en_title'
                                          className='form-control mb-2'
                                          placeholder={t('Title')}
                                          value={field.en_title}
                                          onChange={(event) => handlePremiumChange(index, event)}
                                        />
                                        {premiumErrors[index]?.en_title && (
                                          <div className='text-danger fw-bold'>
                                            {premiumErrors[index].en_title}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg-3 my-3'>
                                        <label className='fs-5 form-label'>{t("Title (Russian)")}</label>
                                        <input
                                          type='text'
                                          name='ru_title'
                                          className='form-control mb-2'
                                          placeholder={t('Title')}
                                          value={field.ru_title}
                                          onChange={(event) => handlePremiumChange(index, event)}
                                        />
                                      </div>
                                      <div className='col-lg-3 my-3'>
                                        <label className='fs-5 form-label'>{t("Title (Uzbek)")}</label>
                                        <input
                                          type='text'
                                          name='uz_title'
                                          className='form-control mb-2'
                                          placeholder={t('Title')}
                                          value={field.uz_title}
                                          onChange={(event) => handlePremiumChange(index, event)}
                                        />
                                      </div>
                                    </>
                                  )}
                                  {primaryLanguage === 'Russian' && (
                                    <>
                                      <div className='col-lg-3 my-3'>
                                        <label className='required fs-5 form-label'>
                                          {t("Title (Russian)")}
                                        </label>
                                        <input
                                          type='text'
                                          name='ru_title'
                                          className='form-control mb-2'
                                          placeholder={t('Title')}
                                          value={field.ru_title}
                                          onChange={(event) => handlePremiumChange(index, event)}
                                        />
                                        {premiumErrors[index]?.ru_title && (
                                          <div className='text-danger fw-bold'>
                                            {premiumErrors[index].ru_title}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg-3 my-3'>
                                        <label className='fs-5 form-label'>{t("Title (English)")}</label>
                                        <input
                                          type='text'
                                          name='en_title'
                                          className='form-control mb-2'
                                          placeholder={t('Title')}
                                          value={field.en_title}
                                          onChange={(event) => handlePremiumChange(index, event)}
                                        />
                                      </div>
                                      <div className='col-lg-3 my-3'>
                                        <label className='fs-5 form-label'>{t("Title (Uzbek)")}</label>
                                        <input
                                          type='text'
                                          name='uz_title'
                                          className='form-control mb-2'
                                          placeholder={t('Title')}
                                          value={field.uz_title}
                                          onChange={(event) => handlePremiumChange(index, event)}
                                        />
                                      </div>
                                    </>
                                  )}
                                  {primaryLanguage === 'Uzbek' && (
                                    <>
                                      <div className='col-lg-3 my-3'>
                                        <label className='required fs-5 form-label'>
                                          {t("Title (Uzbek)")}
                                        </label>
                                        <input
                                          type='text'
                                          name='uz_title'
                                          className='form-control mb-2'
                                          placeholder={t('Title')}
                                          value={field.uz_title}
                                          onChange={(event) => handlePremiumChange(index, event)}
                                        />
                                        {premiumErrors[index]?.uz_title && (
                                          <div className='text-danger fw-bold'>
                                            {premiumErrors[index].uz_title}
                                          </div>
                                        )}
                                      </div>
                                      <div className='col-lg-3 my-3'>
                                        <label className='fs-5 form-label'>{t("Title (Russian)")}</label>
                                        <input
                                          type='text'
                                          name='ru_title'
                                          className='form-control mb-2'
                                          placeholder={t('Title')}
                                          value={field.ru_title}
                                          onChange={(event) => handlePremiumChange(index, event)}
                                        />
                                      </div>
                                      <div className='col-lg-3 my-3'>
                                        <label className='fs-5 form-label'>{t("Title (English)")}</label>
                                        <input
                                          type='text'
                                          name='en_title'
                                          className='form-control mb-2'
                                          placeholder={t('Title')}
                                          value={field.en_title}
                                          onChange={(event) => handlePremiumChange(index, event)}
                                        />
                                      </div>
                                    </>
                                  )}
                                  <div className='col-lg-12 mb-3 d-flex justify-content-end align-items-end'>
                                    {index !== 0 && (
                                      <button
                                        className='btn btn-danger mx-1 mb-2'
                                        onClick={() => handleRemovePremiumField(index)}
                                      >
                                        x
                                      </button>
                                    )}
                                    <button
                                      className='btn btn-success mx-1 mb-2'
                                      onClick={handleAddPremiumField}
                                    >
                                      +
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                      {/* <!--begin::Card body--> */}
                    </div>
                    {/* <!--end::Pricing--> */}
                  </div>
                </div>
                {/* <!--end::Tab pane--> */}
              </div>
              {/* <!--end::Tab content--> */}
              <div className='d-flex justify-content-end'>
                <button
                  type='button'
                  disabled={disable}
                  className='btn btn-primary'
                  onClick={addCarRentalInsuranceApi}
                >
                  <span className='indicator-label'>{t("Next")}</span>
                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm mx-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </button>
                {/* <!--end::Button--> */}
              </div>
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export { AddCarRentalInsurance }
